import { TControlledFormComponentProps } from '@chocolate-soup-inc/cs-frontend-components';

export const getOfficeFormFields = () => {
  const formFields: TControlledFormComponentProps[] = [
    {
      name: 'name',
      label: 'Office Name',
      type: 'textField'
    },
    {
      name: 'legalName',
      label: 'Office Legal Name',
      type: 'textField'
    },
    {
      title: 'Address',
      type: 'section'
    },
    {
      name: 'address.address1',
      label: 'Address Line 1',
      type: 'textField'
    },
    {
      name: 'address.address2',
      label: 'Address Line 2',
      type: 'textField'
    },
    {
      name: 'address.city',
      label: 'City',
      type: 'textField'
    },
    {
      name: 'address.state',
      label: 'Province / State',
      type: 'textField'
    },
    {
      name: 'address.zipCode',
      label: 'Zip Code',
      type: 'textField'
    },
    {
      name: 'address.country',
      label: 'Country',
      type: 'countrySelect'
    },
    {
      title: 'Contact',
      type: 'section'
    },
    {
      name: 'contact.name',
      label: 'Name',
      type: 'textField'
    },
    {
      name: 'contact.email',
      label: 'Email',
      type: 'textField'
    },
    {
      name: 'contact.phoneNumber',
      label: 'Phone Number',
      type: 'textField'
    }
  ];

  return formFields;
};
